export default __webpack_public_path__ + "static/media/parkingCarReduced.inactive.50f3cd05.svg";